/**
 * 豆包语音合成 · 公版音色预设（仅「语音合成模型 2.0」音色库：voice_type 为 *_uranus_bigtts）
 * X-Api-Resource-Id：seed-tts-2.0
 * 完整列表与场景分类以控制台为准：https://www.volcengine.com/docs/6561/1257544?lang=zh
 */
export const VOLC_SPEAKER_CUSTOM_ID = '__custom__'

export const VOLC_RESOURCE_TTS_2 = 'seed-tts-2.0'

/** @type {{ id: string, label: string, resourceId: string }[]} */
export const VOLC_TTS_SPEAKER_PRESETS = [
  { id: 'zh_female_shuangkuaisisi_uranus_bigtts', label: '爽快思思 · 2.0', resourceId: VOLC_RESOURCE_TTS_2 },
  { id: 'zh_female_cancan_uranus_bigtts', label: '知性灿灿 · 2.0', resourceId: VOLC_RESOURCE_TTS_2 },
  { id: 'zh_female_tianmeixiaoyuan_uranus_bigtts', label: '甜美小源 · 2.0', resourceId: VOLC_RESOURCE_TTS_2 },
  { id: 'zh_female_tianmeitaozi_uranus_bigtts', label: '甜美桃子 · 2.0', resourceId: VOLC_RESOURCE_TTS_2 },
  { id: 'zh_female_sajiaoxuemei_uranus_bigtts', label: '撒娇学妹 · 2.0', resourceId: VOLC_RESOURCE_TTS_2 },
  { id: 'zh_female_qingxinnvsheng_uranus_bigtts', label: '清新女声 · 2.0', resourceId: VOLC_RESOURCE_TTS_2 },
  { id: 'zh_female_vv_uranus_bigtts', label: 'Vivi · 2.0', resourceId: VOLC_RESOURCE_TTS_2 },
  { id: 'zh_male_wennuanshuimu_uranus_bigtts', label: '温暖水母 · 2.0', resourceId: VOLC_RESOURCE_TTS_2 },
  { id: 'zh_male_liufei_uranus_bigtts', label: '刘飞 · 2.0', resourceId: VOLC_RESOURCE_TTS_2 },
  { id: 'zh_male_sophie_uranus_bigtts', label: '魅力苏菲 · 2.0', resourceId: VOLC_RESOURCE_TTS_2 },
  { id: 'zh_male_m191_uranus_bigtts', label: '云舟 M191 · 2.0', resourceId: VOLC_RESOURCE_TTS_2 },
  { id: 'zh_male_dayi_uranus_bigtts', label: '大壹 · 2.0', resourceId: VOLC_RESOURCE_TTS_2 },
  { id: 'zh_male_sunwukong_uranus_bigtts', label: '猴哥 · 2.0', resourceId: VOLC_RESOURCE_TTS_2 },
  { id: 'zh_male_taocheng_uranus_bigtts', label: '小天 · 2.0', resourceId: VOLC_RESOURCE_TTS_2 },
  { id: 'zh_male_shaonianzixin_uranus_bigtts', label: '少年梓辛 · 2.0', resourceId: VOLC_RESOURCE_TTS_2 },
  { id: 'zh_male_ruyayichen_uranus_bigtts', label: '儒雅逸辰 · 2.0', resourceId: VOLC_RESOURCE_TTS_2 }
]

export const VOLC_TTS_DEFAULT_SPEAKER_ID =
  VOLC_TTS_SPEAKER_PRESETS[0] ? VOLC_TTS_SPEAKER_PRESETS[0].id : 'zh_female_shuangkuaisisi_uranus_bigtts'

/**
 * 按 speaker id 猜测资源（自定义输入且不在预设表中时）
 */
export function inferVolcTtsResourceIdFromSpeakerId(speakerId) {
  const s = String(speakerId || '').trim().toLowerCase()
  if (!s || s === VOLC_SPEAKER_CUSTOM_ID) return ''
  if (s.includes('_uranus_bigtts') || s.includes('_uranus_')) return VOLC_RESOURCE_TTS_2
  return ''
}

/**
 * @param {string} speakerId
 * @returns {string} 匹配的 resource_id，未知则返回空（走后端默认）
 */
export function getVolcTtsResourceIdForSpeaker(speakerId) {
  const s = String(speakerId || '').trim()
  if (!s || s === VOLC_SPEAKER_CUSTOM_ID) return ''
  const hit = VOLC_TTS_SPEAKER_PRESETS.find(p => p.id === s)
  if (hit) return hit.resourceId
  return inferVolcTtsResourceIdFromSpeakerId(s)
}

/**
 * @param {string} publicSpeakerId 当前节点存的 speaker
 * @returns {string} 下拉框 value：预设 id 或 VOLC_SPEAKER_CUSTOM_ID
 */
export function inferVolcSpeakerPick(publicSpeakerId) {
  const s = String(publicSpeakerId || '').trim()
  if (!s) return VOLC_TTS_DEFAULT_SPEAKER_ID
  if (VOLC_TTS_SPEAKER_PRESETS.some(p => p.id === s)) return s
  return VOLC_SPEAKER_CUSTOM_ID
}
